import { Box, Button, IconButton, Tooltip, makeStyles } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { truncateWithEllipsis } from '../../helpers/common';
import { borderRadiusBoxes, themePalette } from '../Dashboards/State/stateTreeStyles';

const useStyles = makeStyles(() => ({
	listRoot: {
		display: 'flex',
		flexDirection: 'column',
		gap: '0.45rem',
	},
	headerRow: {
		display: 'grid',
		gridTemplateColumns: 'minmax(0, 1.8fr) minmax(96px, 0.9fr) 2.2rem',
		alignItems: 'center',
		columnGap: '0.55rem',
		padding: '0 0.25rem',
	},
	headerCell: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: '2rem',
		padding: '0.25rem 0.65rem',
		borderRadius: borderRadiusBoxes,
		fontSize: '0.78rem',
		fontWeight: 600,
		color: themePalette.text.secondary,
		backgroundColor: 'rgba(241, 245, 249, 0.95)',
		textAlign: 'center',
	},
	hideHeaderOnMobile: {},
	userRow: {
		display: 'grid',
		gridTemplateColumns: 'minmax(0, 1.8fr) minmax(96px, 0.9fr) 2.2rem',
		alignItems: 'center',
		columnGap: '0.55rem',
		padding: '0.45rem 0.25rem',
		borderRadius: borderRadiusBoxes,
		border: `1px solid ${themePalette.border.soft}`,
		backgroundColor: themePalette.common.white,
	},
	email: {
		minWidth: 0,
		fontSize: '0.95rem',
		color: themePalette.primary.main,
		lineHeight: 1.3,
		wordBreak: 'break-word',
	},
	status: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		minWidth: 0,
		padding: '0.2rem 0.5rem',
		borderRadius: borderRadiusBoxes,
		fontSize: '0.76rem',
		fontWeight: 700,
		textTransform: 'uppercase',
		letterSpacing: '0.03em',
		color: themePalette.primary.main,
		backgroundColor: 'rgba(224, 242, 254, 0.9)',
		border: `1px solid rgba(125, 211, 252, 0.9)`,
		textAlign: 'center',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	editButton: {
		padding: 6,
		color: themePalette.primary.main,
	},
	editButtonWrap: {},
	emptyState: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: '0.75rem',
		padding: '0.2rem 0',
		fontSize: '0.95rem',
		color: themePalette.text.secondary,
	},
	emptyButton: {
		textTransform: 'none',
		borderRadius: borderRadiusBoxes,
	},
	'@media (max-width: 600px)': {
		headerRow: {
			gridTemplateColumns: 'minmax(0, 1fr) 2.2rem',
		},
		headerCell: {
			justifyContent: 'flex-start',
			fontSize: '0.72rem',
			padding: '0.22rem 0.55rem',
		},
		hideHeaderOnMobile: {
			display: 'none',
		},
		userRow: {
			gridTemplateColumns: 'minmax(0, 1fr) 2.2rem',
			gridTemplateAreas: `"email action" "status action"`,
			rowGap: '0.35rem',
			padding: '0.55rem 0.25rem',
		},
		email: {
			gridArea: 'email',
			fontSize: '0.9rem',
		},
		status: {
			gridArea: 'status',
			justifySelf: 'flex-start',
			maxWidth: '100%',
			fontSize: '0.7rem',
		},
		editButtonWrap: {
			gridArea: 'action',
			alignSelf: 'center',
			justifySelf: 'center',
		},
	},
}));

export default function UsersList({ shared }) {
	const classes = useStyles();
	const history = useHistory();

	const goToSubaccounts = () => {
		history.push('/configuracion-subcuentas');
	};

	if (shared.length === 0) {
		return (
			<Box className={classes.emptyState}>
				<Box component='span'>El nodo seleccionado no posee invitaciones</Box>
				<Button
					aria-label='edit'
					color='primary'
					variant='outlined'
					onClick={goToSubaccounts}
					className={classes.emptyButton}
				>
					Ir a Configuracion Sub-Cuentas
				</Button>
			</Box>
		);
	}

	return (
		<Box className={classes.listRoot}>
			<Box className={classes.headerRow}>
				<Box className={classes.headerCell}>Mail</Box>
				<Box className={`${classes.headerCell} ${classes.hideHeaderOnMobile}`}>Estado</Box>
				<Box />
			</Box>

			{shared.map((user, index) => (
				<Box className={classes.userRow} key={index}>
					<Box className={classes.email} title={user.email}>
						{truncateWithEllipsis(user.email, 32)}
					</Box>
					<Box className={classes.status} title={user.status}>
						{user.status}
					</Box>
					<Box className={classes.editButtonWrap}>
						<Tooltip title='Editar Sub-Cuenta'>
							<IconButton aria-label='edit' onClick={goToSubaccounts} className={classes.editButton}>
								<EditIcon fontSize='small' />
							</IconButton>
						</Tooltip>
					</Box>
				</Box>
			))}
		</Box>
	);
}
